import { logger } from '@cred/fe-logger'

export default function snowplowValueWithLength(key, value, length) {
  if (!value) {
    return value
  }

  if (value.length > length) {
    logger?.error?.(
      'Snowplow value has been cut',
      { key, value },
      `${key} is ${value.length} characters long, max is ${length}`,
    )
    return `${value.substring(0, length - 3)}...`
  }

  return value
}
